import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import TaskDetails from './TaskDetails';

export default function BulkUnlock({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Unlock"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects(projectId)
          .tasks()
          .bulkSetLockTime(ids, { lockTime: false })
          .then((r) => r.data)
      }
      renderRow={TaskDetails}>
      {`Are you sure you want to unlock time tracking on ${ids.length} ${pluralize('task', ids.length)}?`}
    </BulkActionModal>
  );
}
